import { forkJoin, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { EntitySettingTypes, EntityType, GqlService } from '@shared/services/gql.service';
import { GlobalState } from '@shared/store/global/global.model';

export const fetchTrialAttributes = (trialId: string, gqlService: GqlService) => {
  if (!trialId) {
    return of({});
  }

  return forkJoin([
    gqlService
      .listEntitySettings$({
        entity_ids: [trialId],
        entity_type: EntityType.TRIAL,
        setting_type: EntitySettingTypes.CLOSE_HIERARCHY,
      })
      .pipe(
        map((response) => {
          if (response.success && response.data && response.data.length > 0) {
            try {
              const settings = JSON.parse(
                response.data[0]?.settings || '{"ATTRIBUTES":{"PRIMARY":"","SECONDARY":""}}'
              );

              return {
                primary: settings?.ATTRIBUTES?.PRIMARY,
                secondary: settings?.ATTRIBUTES?.SECONDARY,
                success: response.success,
              };
            } catch (e) {
              console.error(e);
            }
          }

          if (response.errors.length) response.errors.forEach((error) => console.error(error));

          return {
            primary: '',
            secondary: '',
            success: response.success,
          };
        })
      ),
    gqlService.listTrialAttributes$(true),
  ]).pipe(
    map(([{ primary, secondary, success }, { data }]) => {
      const attributes = (data || []).sort((a, b) => a.attribute_index - b.attribute_index);
      const primaryAttribute = attributes.find((a) => a.attribute_name === primary);
      const secondaryAttribute = attributes.find((a) => a.attribute_name === secondary);

      return <Partial<GlobalState>>{
        attributes,
        hierarchyAttributesLoaded: success,
        primaryAttribute: {
          attribute_name: primary,
          expense_populated: primaryAttribute?.attribute_expense_populated || false,
          values_populated: primaryAttribute?.attribute_values_populated || false,
        },
        secondaryAttribute: {
          attribute_name: secondary,
          expense_populated: secondaryAttribute?.attribute_expense_populated || false,
          values_populated: secondaryAttribute?.attribute_values_populated || false,
        },
      };
    })
  );
};
